{
  "nav": {
    "label": "เนื้อหาเว็บไซต์",
    "pages": "หน้าเว็บ",
    "policies": "นโยบายร้าน",
    "menus": "เมนู",
    "redirects": "ลิงก์เปลี่ยนเส้นทาง",
    "announcements": "ประกาศ",
    "translations": "คำแปล",
    "website_texts": "ข้อความบนเว็บ",
    "languages": "ภาษา",
    "media": "รูปและไฟล์"
  },
  "common": {
    "cancel": "ยกเลิก",
    "close": "ปิด",
    "delete": "ลบ",
    "edit": "แก้ไข",
    "save": "บันทึก",
    "saving": "กำลังบันทึก…",
    "loading": "กำลังโหลด…",
    "load_more": "แสดงเพิ่ม",
    "japan_time": "เวลาญี่ปุ่น (JST)"
  },
  "errors": {
    "generic": "มีบางอย่างผิดพลาด ลองใหม่อีกครั้ง",
    "network": "ติดต่อเซิร์ฟเวอร์ไม่ได้ ตรวจอินเทอร์เน็ตแล้วลองใหม่",
    "forbidden": "บัญชีของคุณทำสิ่งนี้ไม่ได้ ขอสิทธิ์จากเจ้าของร้าน",
    "version_conflict": "มีคนอื่นบันทึกก่อนคุณ",
    "if_match_required": "มีคนอื่นแก้ไว้ก่อนแล้ว โหลดหน้าใหม่แล้วลองอีกครั้ง",
    "handle_taken": "ที่อยู่เว็บนี้มีหน้าอื่นใช้อยู่แล้ว",
    "validation_failed": "มีค่าบางช่องไม่ถูกต้อง ดูช่องที่ไฮไลต์",
    "page_not_found": "ไม่พบหน้านี้แล้ว",
    "page_trashed": "หน้านี้อยู่ในถังขยะ — กู้คืนก่อน",
    "policy_incomplete": "ยังมีช่องที่จำเป็นว่างอยู่",
    "menu_in_use": "เมนูนี้แสดงอยู่บนเว็บ ให้เอาออกจากหน้าตาเว็บไซต์ก่อน",
    "menu_depth_exceeded": "เมนูมีได้สูงสุด 3 ชั้น",
    "menu_too_large": "เมนูนี้มีรายการมากเกินไป",
    "redirect_exists": "ที่อยู่เดิมนี้มีลิงก์เปลี่ยนเส้นทางแล้ว",
    "redirect_invalid": "ที่อยู่เดิมหรือที่อยู่ใหม่ไม่ถูกต้อง",
    "redirect_loop": "จะทำให้ลูกค้าวนกลับมาที่เดิมไม่รู้จบ",
    "redirect_chain_too_long": "ส่งต่อกันหลายทอดเกินไป — ให้ชี้ที่อยู่เดิมไปหน้าสุดท้ายตรง ๆ",
    "announcement_limit_exceeded": "ประกาศเยอะเกินไป ลบอันเก่าก่อน",
    "locale_required": "ต้องเปิดภาษาอังกฤษ (ภาษาหลัก) ไว้เสมอ",
    "translator_not_configured": "ยังไม่ได้เปิดใช้การแปลอัตโนมัติ",
    "placeholder_mismatch": "คำใน { } ไม่ตรงกับข้อความภาษาอังกฤษ",
    "icu_syntax_invalid": "ข้อความมี { หรือ } ที่ไม่ครบคู่",
    "rate_limited": "แก้หลายอย่างพร้อมกันเกินไป รอสักครู่แล้วลองใหม่"
  },
  "unsaved": {
    "title": "ออกโดยไม่บันทึก?",
    "body": "สิ่งที่แก้ในหน้านี้ยังไม่ได้บันทึก",
    "leave": "ออกและทิ้งที่แก้",
    "stay": "อยู่ต่อ"
  },
  "locale": {
    "missing_sr": "(ยังไม่แปล)",
    "dots_label": "ภาษา",
    "tabs_for": "ภาษาของ {{label}}",
    "english_required": "ใส่ข้อความภาษาอังกฤษด้วย — ภาษาอังกฤษเป็นภาษาหลักของเว็บ",
    "state": {
      "missing": "ยังไม่แปล",
      "draft": "ต้องตรวจ",
      "reviewed": "แปลแล้ว"
    }
  },
  "status": {
    "published": "เผยแพร่แล้ว",
    "draft": "ร่าง",
    "scheduled": "ตั้งเวลา",
    "scheduled_at": "ตั้งเวลา · {{time}}",
    "trashed": "ในถังขยะ"
  },
  "preview": {
    "loading": "กำลังเตรียมตัวอย่าง…",
    "unavailable": "แสดงตัวอย่างไม่ได้ตอนนี้ (เว็บอาจยังไม่ทำงาน)",
    "open_new_tab": "เปิดตัวอย่างในแท็บใหม่"
  },
  "pages": {
    "title": "หน้าเว็บ",
    "intro": "หน้าข้อมูล เช่น เกี่ยวกับเรา ติดต่อเรา หรือเกณฑ์ Rank",
    "new": "สร้างหน้าใหม่",
    "search": "ค้นหาหน้า",
    "search_placeholder": "ชื่อหรือที่อยู่เว็บ",
    "filter": "แสดง",
    "filter_all": "ทั้งหมด",
    "filter_published": "เผยแพร่แล้ว",
    "filter_draft": "ร่าง",
    "filter_scheduled": "ตั้งเวลา",
    "filter_trashed": "ถังขยะ",
    "empty": "ยังไม่มีหน้าในส่วนนี้",
    "updated": "แก้ล่าสุด {{time}}"
  },
  "page_editor": {
    "new_title": "หน้าใหม่",
    "create": "สร้างหน้า",
    "preview": "ดูตัวอย่าง",
    "preview_frame": "ตัวอย่างหน้าเว็บ (ร่าง)",
    "languages": "ภาษา",
    "side_by_side": "เทียบ 2 ภาษาข้างกัน",
    "side_hint": "เลือกภาษาของแต่ละฝั่ง แก้ได้ทั้งสองฝั่ง",
    "side_left": "ซ้าย",
    "side_right": "ขวา",
    "title_label": "ชื่อหน้า ({{language}})",
    "body_label": "เนื้อหา ({{language}})",
    "copy_from_en": "คัดลอกจากอังกฤษ",
    "copied": "คัดลอกข้อความภาษาอังกฤษไปที่ {{language}} แล้ว กรุณาแปลและตรวจอีกครั้ง",
    "please_check": "คัดลอกมา — กรุณาตรวจ",
    "visibility": "แสดงบนเว็บเมื่อไร",
    "mode_draft": "เก็บเป็นร่าง (ยังไม่แสดงบนเว็บ)",
    "mode_now": "แสดงบนเว็บเดี๋ยวนี้",
    "mode_schedule": "ตั้งเวลาแสดง",
    "publish_now": "เผยแพร่เดี๋ยวนี้",
    "publish_at": "วันและเวลา",
    "schedule": "ตั้งเวลาเผยแพร่",
    "unpublish": "เอาออกจากเว็บ",
    "cancel_schedule": "ยกเลิกเวลาที่ตั้งไว้",
    "trash": "ย้ายไปถังขยะ",
    "trash_title": "ย้ายหน้านี้ไปถังขยะ?",
    "trash_body": "หน้านี้จะหายจากเว็บ กู้คืนจากถังขยะได้ภายหลัง",
    "restore": "กู้คืนจากถังขยะ",
    "restored": "กู้คืนหน้าแล้ว (เป็นร่าง)",
    "published_ok": "หน้านี้แสดงบนเว็บแล้ว",
    "scheduled_ok": "หน้านี้จะเผยแพร่ตามเวลาที่ตั้ง",
    "unpublished": "เอาหน้านี้ออกจากเว็บแล้ว",
    "schedule_cancelled": "ยกเลิกเวลาที่ตั้งแล้ว หน้านี้เป็นร่าง",
    "created_draft": "สร้างหน้าเป็นร่างแล้ว",
    "created_now": "สร้างหน้าและแสดงบนเว็บแล้ว",
    "created_schedule": "สร้างหน้าแล้ว จะเผยแพร่ตามเวลาที่ตั้ง",
    "saved": "บันทึกแล้ว",
    "needs_english": "ใส่ชื่อหน้าภาษาอังกฤษก่อน — ภาษาอังกฤษเป็นภาษาหลักของเว็บ",
    "when_invalid": "เลือกวันและเวลา",
    "settings": "ตั้งค่าหน้า",
    "handle": "ที่อยู่เว็บ",
    "handle_hint": "ใช้ตัวพิมพ์เล็ก ตัวเลข และ - เท่านั้น เช่น about-us",
    "handle_invalid": "ใช้ตัวพิมพ์เล็ก (a–z) ตัวเลข และ - เท่านั้น เช่น rank-standards",
    "handle_taken": "มีหน้าอื่นใช้ที่อยู่เว็บนี้แล้ว",
    "handle_redirect": "เมื่อบันทึก คนที่เปิดที่อยู่เดิม {{from}} จะถูกพาไปที่อยู่ใหม่ให้อัตโนมัติ (สร้างลิงก์เปลี่ยนเส้นทางให้)",
    "kind": "แบบของหน้า",
    "kind_default": "หน้าทั่วไป",
    "kind_contact": "หน้าติดต่อ (มีฟอร์มส่งข้อความ)",
    "kind_help": "ศูนย์ช่วยเหลือ",
    "kind_faq": "คำถามที่พบบ่อย",
    "kind_other": "หน้าแบบ “{{name}}”",
    "seo": "การค้นหาบน Google",
    "seo_title": "ชื่อที่แสดงในผลค้นหา",
    "seo_description": "คำอธิบายในผลค้นหา",
    "chars": "{{count}} ตัวอักษร (ประมาณ {{advice}} กำลังดี)",
    "google_sample": "ตัวอย่างผลบน Google",
    "conflict": "มีคนอื่นบันทึกหน้านี้ระหว่างที่คุณแก้",
    "conflict_reload": "โหลดของเขา (ที่ฉันแก้จะหาย)",
    "conflict_overwrite": "ใช้ของฉันทับ",
    "warnings_title": "ตอนบันทึก มีบางส่วนของเนื้อหาถูกปรับ:"
  },
  "content_warning": {
    "unsupported_node": "ส่วนที่เว็บแสดงไม่ได้ถูกเปลี่ยนเป็นข้อความธรรมดา",
    "unsupported_mark": "รูปแบบตัวอักษรที่เว็บแสดงไม่ได้ถูกเอาออก",
    "link_not_allowed": "ลิงก์ที่ไม่อนุญาตถูกเอาออก",
    "image_src_not_media": "รูปที่ไม่ได้มาจากคลังรูปถูกเอาออก — เพิ่มจากคลังรูปแทน",
    "embed_not_allowed": "วิดีโอที่ไม่ใช่ YouTube หรือ Vimeo ถูกเอาออก",
    "other": "มีบางอย่างที่เว็บแสดงไม่ได้ถูกเอาออก"
  },
  "richtext": {
    "toolbar": "เครื่องมือข้อความของ {{label}}",
    "style": "รูปแบบข้อความ",
    "paragraph": "ข้อความปกติ",
    "h2": "หัวข้อใหญ่",
    "h3": "หัวข้อ",
    "h4": "หัวข้อย่อย",
    "bold": "ตัวหนา",
    "italic": "ตัวเอียง",
    "underline": "ขีดเส้นใต้",
    "strike": "ขีดฆ่า",
    "bullet": "รายการแบบจุด",
    "ordered": "รายการแบบตัวเลข",
    "quote": "ข้อความอ้างอิง",
    "link": "ลิงก์",
    "unlink": "เอาลิงก์ออก",
    "image": "รูป",
    "image_pick": "เลือกรูป",
    "image_placeholder": "รูป: {{name}}",
    "image_alt": "คำอธิบาย: {{alt}}",
    "image_no_alt": "ยังไม่มีคำอธิบายรูป — ใส่ด้านล่าง",
    "image_alt_label": "คำอธิบายรูป (สำหรับคนที่มองไม่เห็นรูป)",
    "image_alt_hint": "บอกว่าในรูปมีอะไร เช่น “การ์ดพิคาชู Rank A ด้านหน้า”",
    "video": "วิดีโอ YouTube / Vimeo",
    "video_url": "ที่อยู่ของวิดีโอ",
    "video_invalid": "วางที่อยู่ YouTube หรือ Vimeo เช่น https://www.youtube.com/watch?v=…",
    "embed_placeholder": "วิดีโอ {{provider}} ({{id}})",
    "table": "ตาราง",
    "table_tools": "ตาราง",
    "add_row": "เพิ่มแถว",
    "add_column": "เพิ่มคอลัมน์",
    "delete_row": "ลบแถว",
    "delete_column": "ลบคอลัมน์",
    "delete_table": "ลบตาราง",
    "callout": "กล่องข้อความเด่น",
    "callout_kind": "ชนิดกล่อง",
    "callout_info": "ข้อมูล",
    "callout_tip": "เคล็ดลับ",
    "callout_warning": "คำเตือน",
    "callout_success": "ข่าวดี",
    "callout_note": "หมายเหตุ",
    "rule": "เส้นคั่น",
    "more": "เพิ่มเติม",
    "undo": "เลิกทำ",
    "redo": "ทำซ้ำ",
    "link_address": "ลิงก์ไปที่",
    "link_invalid": "ใช้ที่อยู่ที่ขึ้นต้นด้วย https://, / (หน้าของร้าน), mailto: หรือ tel:",
    "link_pick": "หรือเลือกจากร้าน:",
    "pick_page": "หน้าข้อมูล",
    "pick_policy": "หน้านโยบายร้าน",
    "pick_collection": "หมวดสินค้า",
    "pick_product": "สินค้า",
    "choose": "เลือก…",
    "new_tab": "เปิดในแท็บใหม่",
    "apply": "ใช้",
    "insert": "ใส่",
    "paste_images_dropped": "รูปที่วางมาจากโปรแกรมอื่นจะไม่ถูกเก็บ ให้เพิ่มด้วยปุ่ม “รูป” (คลังรูป)"
  },
  "policies": {
    "title": "นโยบายร้าน",
    "intro": "หน้าที่กฎหมายกำหนดให้ร้านต้องแสดง แต่ละหน้าบอกว่ายังขาดอะไรก่อนเปิดร้าน",
    "edit": "เปิด",
    "complete": "ครบ",
    "missing_other": "ขาด {{count}} ช่อง ({{languages}})",
    "published": "เผยแพร่แล้ว (เวอร์ชัน {{version}}, {{time}})",
    "not_published": "ยังไม่เผยแพร่",
    "unpublished_changes": "มีการแก้ที่ยังไม่เผยแพร่",
    "weight_law": "กฎหมายกำหนด",
    "weight_recommended": "แนะนำให้มี",
    "type": {
      "tokushoho": "ข้อมูลตามกฎหมาย (特定商取引法に基づく表記)",
      "privacy": "นโยบายความเป็นส่วนตัว",
      "terms": "ข้อกำหนดการใช้บริการ",
      "returns": "การคืนสินค้า (返品特約)",
      "shipping": "การจัดส่ง",
      "kobutsu": "ประกาศใบอนุญาตค้าของเก่า (古物営業法)",
      "contact": "ติดต่อเรา"
    },
    "legal": {
      "tokushoho": "ร้านออนไลน์ในญี่ปุ่นต้องแสดงว่าใครขาย จ่ายเงินอย่างไร ส่งเมื่อไร และเงื่อนไขการคืนสินค้า",
      "returns": "กฎหมายกำหนดให้แสดงบนเว็บ มิฉะนั้นลูกค้ายกเลิกได้ภายใน 8 วัน",
      "privacy": "กฎหมายข้อมูลส่วนบุคคล (APPI) ให้บอกว่าร้านทำอะไรกับข้อมูลลูกค้า รวมถึงข้อมูลที่เก็บต่างประเทศ",
      "kobutsu": "ร้านที่ซื้อขายของมือสองต้องแสดงใบอนุญาตค้าของเก่าบนเว็บ",
      "terms": "กติกาการใช้เว็บและการซื้อสินค้า",
      "shipping": "ส่งอย่างไร ส่งไปที่ไหน และลูกค้าต่างประเทศต้องจ่ายอะไรเพิ่ม",
      "contact": "ลูกค้าติดต่อร้านได้อย่างไร"
    }
  },
  "policy_editor": {
    "unknown": "ไม่มีหน้านี้",
    "save_draft": "บันทึกร่าง",
    "saved": "บันทึกร่างแล้ว ยังไม่แสดงบนเว็บจนกว่าจะกดเผยแพร่",
    "preview": "ดูตัวอย่าง",
    "preview_frame": "ตัวอย่างหน้านโยบายร้าน (ร่าง)",
    "shared_title": "ข้อมูลเดียวกันทุกภาษา",
    "shared_hint": "เบอร์โทร อีเมล ที่อยู่เว็บ และเลขใบอนุญาต กรอกครั้งเดียวใช้ทุกภาษา",
    "page_title": "ชื่อหน้า ({{language}})",
    "page_title_hint": "เว้นว่างเพื่อใช้ชื่อมาตรฐาน",
    "body": "เนื้อหา ({{language}})",
    "body_name": "เนื้อหาของหน้า",
    "locale_required": "ต้องกรอก {{language}} ให้ครบก่อนเผยแพร่",
    "locale_optional": "{{language}} ไม่บังคับ — ช่องที่ว่างจะแสดงภาษาอังกฤษแทน",
    "required_in": "จำเป็น: {{languages}}",
    "example": "ตัวอย่าง: {{example}}",
    "missing_in": "ยังว่าง — ต้องกรอกเป็น{{language}}ก่อนเผยแพร่",
    "missing_shared": "ยังว่าง — ต้องกรอกก่อนเผยแพร่",
    "missing_title": "ยังขาด:",
    "missing_item": "{{language}}: {{field}}",
    "incomplete": "ยังเผยแพร่ไม่ได้ — มีช่องที่จำเป็นว่างอยู่ (ไฮไลต์สีแดง)",
    "publish_title": "เผยแพร่",
    "note": "บันทึกช่วยจำ (ไม่บังคับ)",
    "publish": "เผยแพร่นโยบาย",
    "publish_hint": "ภาษาญี่ปุ่นและอังกฤษต้องครบ ภาษาอื่นแค่เตือน",
    "publish_needs_manager": "เจ้าของร้านหรือผู้จัดการเท่านั้นที่เผยแพร่ได้ บันทึกร่างแล้วแจ้งเขา",
    "published": "เผยแพร่แล้ว (เวอร์ชัน {{version}})",
    "published_with_gaps": "เผยแพร่แล้ว (เวอร์ชัน {{version}}) ยังไม่แปล: {{languages}} — ลูกค้าภาษานั้นจะเห็นภาษาอังกฤษ",
    "nothing_new": "ไม่มีอะไรใหม่ให้เผยแพร่ — เว็บแสดงแบบนี้อยู่แล้ว",
    "suggest_payments": "ดึงวิธีชำระเงินจากการตั้งค่า",
    "suggested": "เติมจากการตั้งค่าการชำระเงินแล้ว กรุณาตรวจถ้อยคำ",
    "suggest_unavailable": "อ่านการตั้งค่าการชำระเงินไม่ได้ตอนนี้ กรุณาพิมพ์เอง",
    "checklist_title": "ช่องที่จำเป็น",
    "checklist_appi": "สิ่งที่ APPI กำหนดให้ต้องมี",
    "versions": "เวอร์ชันที่เผยแพร่",
    "version_line": "เวอร์ชัน {{version}} · {{time}}",
    "no_versions": "ยังไม่เคยเผยแพร่",
    "placeholder": "ยังเป็นข้อความตัวอย่างใน [[ ]] — แทนด้วยข้อมูลจริงของร้าน"
  },
  "policy_fields": {
    "business_name": {
      "label": "ผู้ขาย (ชื่อร้านหรือบริษัท)",
      "hint": "ชื่อผู้ประกอบการที่ขาย ตามที่จดทะเบียน",
      "example": "株式会社〇〇 / TCG Shop Tokyo"
    },
    "representative": {
      "label": "ผู้รับผิดชอบ",
      "hint": "ผู้แทนหรือผู้รับผิดชอบร้านออนไลน์",
      "example": "山田 太郎"
    },
    "address": {
      "label": "ที่อยู่",
      "hint": "ที่ตั้งของกิจการ เขียนเต็ม",
      "example": "〒150-0001 東京都渋谷区…"
    },
    "phone": {
      "label": "เบอร์โทร",
      "hint": "เบอร์ที่ลูกค้าโทรติดต่อได้",
      "example": "+81-3-1234-5678"
    },
    "phone_hours": {
      "label": "เวลารับโทรศัพท์",
      "hint": "ช่วงเวลาที่รับสาย",
      "example": "10:00–18:00 (หยุดวันพุธ)"
    },
    "email": {
      "label": "อีเมล",
      "hint": "อีเมลสำหรับถามเรื่องคำสั่งซื้อ",
      "example": "support@example.com"
    },
    "url": {
      "label": "เว็บไซต์",
      "hint": "ที่อยู่ของร้านออนไลน์นี้",
      "example": "https://shop.example.com"
    },
    "price_display": {
      "label": "ราคา",
      "hint": "บอกว่าราคารวมภาษีบริโภคแล้ว และแสดงที่ไหน",
      "example": "แสดงที่หน้าสินค้าแต่ละชิ้น (รวมภาษี)"
    },
    "additional_fees": {
      "label": "ค่าใช้จ่ายอื่น",
      "hint": "ค่าส่ง ค่าธรรมเนียมโอน ภาษีนำเข้าของต่างประเทศ",
      "example": "ค่าส่งเริ่มที่ ¥… ค่าธรรมเนียมโอนลูกค้าจ่ายเอง"
    },
    "payment_methods": {
      "label": "วิธีชำระเงิน",
      "hint": "ทุกวิธีที่ลูกค้าจ่ายได้ — หรือกดปุ่มด้านล่าง",
      "example": "โอนธนาคาร, ชำระที่ร้าน"
    },
    "payment_timing": {
      "label": "กำหนดชำระ",
      "hint": "ลูกค้าต้องจ่ายภายในเมื่อไร",
      "example": "ภายใน 3 วันหลังสั่ง"
    },
    "delivery_timing": {
      "label": "ระยะเวลาส่งของ",
      "hint": "ส่งของเมื่อไรหลังชำระเงิน",
      "example": "ส่งภายใน 2 วันทำการหลังชำระเงิน"
    },
    "return_policy": {
      "label": "การคืน/เปลี่ยนสินค้า",
      "hint": "เงื่อนไขการคืนของร้าน (返品特約) ถ้าไม่แสดง ลูกค้ายกเลิกได้ภายใน 8 วัน",
      "example": "เนื่องจากเป็นการ์ดสะสม ไม่รับคืนยกเว้น…"
    },
    "quantity_limit": {
      "label": "จำกัดจำนวน",
      "hint": "ถ้าลูกค้าซื้อได้จำนวนจำกัด",
      "example": "การ์ดส่วนใหญ่มีชิ้นเดียว"
    },
    "application_validity": {
      "label": "อายุคำสั่งซื้อ / การยกเลิก",
      "hint": "คำสั่งซื้อที่ยังไม่จ่ายเก็บไว้นานเท่าไร",
      "example": "ไม่ชำระภายใน 3 วัน คำสั่งซื้อจะถูกยกเลิก"
    },
    "kobutsu_license": {
      "label": "ใบอนุญาตค้าของเก่า",
      "hint": "เว้นว่างเพื่อใช้ข้อมูลจากหน้าประกาศใบอนุญาตค้าของเก่า",
      "example": "東京都公安委員会 第123456789012号"
    },
    "other_notes": {
      "label": "หมายเหตุอื่น",
      "hint": "สิ่งอื่นที่ลูกค้าควรรู้",
      "example": ""
    },
    "controller_name": {
      "label": "ชื่อผู้ประกอบการ",
      "hint": "ผู้รับผิดชอบข้อมูลส่วนบุคคล",
      "example": ""
    },
    "controller_address": {
      "label": "ที่อยู่",
      "hint": "",
      "example": ""
    },
    "purposes": {
      "label": "ใช้ข้อมูลเพื่ออะไร",
      "hint": "เช่น ส่งสินค้า ตอบคำถาม ยืนยันตัวตนตอนรับซื้อการ์ด",
      "example": ""
    },
    "disclosure_procedure": {
      "label": "วิธีขอดู แก้ไข หรือลบข้อมูล",
      "hint": "ลูกค้าขอได้ที่ไหน อย่างไร",
      "example": ""
    },
    "security_measures": {
      "label": "ร้านปกป้องข้อมูลอย่างไร",
      "hint": "รวมถึงประเทศที่เก็บข้อมูล (เช่น ระบบชำระเงินในสหรัฐฯ)",
      "example": ""
    },
    "foreign_transfer": {
      "label": "ข้อมูลที่ส่งไปต่างประเทศ",
      "hint": "บริษัทต่างประเทศใดได้รับข้อมูล และประเทศอะไร",
      "example": ""
    },
    "complaints_contact": {
      "label": "ช่องทางร้องเรียน",
      "hint": "ติดต่อที่ไหนเมื่อมีเรื่องข้อมูลส่วนบุคคล",
      "example": ""
    },
    "final_sale_summary": {
      "label": "เงื่อนไขคืนสินค้า 1 บรรทัด",
      "hint": "แสดงที่หน้าสินค้าและก่อนลูกค้ายืนยันสั่งซื้อ",
      "example": "คืนได้เฉพาะสินค้าที่ไม่ตรงคำอธิบาย"
    },
    "licensee_name": {
      "label": "ชื่อผู้ได้รับอนุญาต",
      "hint": "ชื่อตามใบอนุญาตค้าของเก่า",
      "example": ""
    },
    "commission_name": {
      "label": "คณะกรรมการความปลอดภัยสาธารณะ",
      "hint": "หน่วยงานที่ออกใบอนุญาต",
      "example": "東京都公安委員会"
    },
    "license_number": {
      "label": "เลขใบอนุญาต",
      "hint": "เลขที่อยู่บนใบอนุญาต",
      "example": "第123456789012号"
    },
    "notified_url": {
      "label": "เว็บที่แจ้งไว้",
      "hint": "ที่อยู่เว็บที่แจ้งตำรวจไว้",
      "example": "https://shop.example.com"
    },
    "hours": {
      "label": "เวลาทำการ",
      "hint": "",
      "example": "11:00–20:00"
    },
    "line_url": {
      "label": "LINE",
      "hint": "ที่อยู่ LINE ของร้าน ถ้ามี",
      "example": ""
    }
  },
  "menus": {
    "title": "เมนู",
    "intro": "เมนูด้านบนและด้านล่างของเว็บ",
    "editor_intro": "เลือกรายการเพื่อแก้ ลากหรือใช้ลูกศรเพื่อย้าย (สูงสุด 3 ชั้น)",
    "item_count_other": "{{count}} รายการ",
    "new_name": "ชื่อเมนูใหม่",
    "new_placeholder": "เช่น ส่วนท้าย — ร้านค้า",
    "create": "สร้างเมนู",
    "items": "รายการในเมนู",
    "add": "เพิ่มรายการ",
    "empty": "ยังไม่มีรายการ — เพิ่มรายการแรก",
    "keyboard_hint": "คีย์บอร์ด: Alt + ↑ / ↓ ย้าย, Alt + → ย้ายไปอยู่ใต้รายการด้านบน, Alt + ← ย้ายออก 1 ชั้น",
    "tree_label": "รายการในเมนู",
    "children_of": "รายการใต้ {{name}}",
    "no_label": "(ยังไม่มีชื่อ)",
    "drag": "ลากเพื่อย้าย {{name}}",
    "up": "ย้ายขึ้น",
    "down": "ย้ายลง",
    "indent": "ย้ายไปอยู่ใต้รายการด้านบน",
    "outdent": "ย้ายออก 1 ชั้น",
    "add_child": "เพิ่มรายการย่อย",
    "duplicate": "ทำสำเนา",
    "remove": "ลบ",
    "item_form": "รายการเมนู",
    "pick_item": "เลือกรายการเมนูทางซ้ายเพื่อแก้",
    "label": "ชื่อ",
    "link": "ลิงก์ไปที่",
    "badge": "ป้ายเล็ก",
    "badge_hint": "ไม่บังคับ เช่น NEW หรือ SALE",
    "image": "รูป (สำหรับเมนูใหญ่)",
    "image_hint": "ไม่บังคับ — แสดงในเมนูแบบใหญ่และบนมือถือ",
    "image_pick": "เลือกรูป",
    "image_change": "เปลี่ยนรูป",
    "image_remove": "เอารูปออก",
    "new_tab": "เปิดในแท็บใหม่",
    "menu_name": "ชื่อเมนู",
    "handle": "บนเว็บใช้ชื่อ “{{handle}}”",
    "saved": "บันทึกเมนูแล้ว เว็บจะแสดงภายในไม่กี่วินาที",
    "problem_label": "ยังไม่มีชื่อภาษาอังกฤษ",
    "fix_first_other": "มี {{count}} รายการที่ต้องแก้ก่อนบันทึก",
    "too_many": "เมนูหนึ่งมีได้สูงสุด {{max}} รายการ",
    "delete": "ลบเมนู",
    "delete_title": "ลบเมนูนี้?",
    "delete_body": "เมนูและทุกรายการในเมนูจะถูกลบ",
    "in_use": "เมนูนี้แสดงอยู่บนเว็บ ให้เลือกเมนูอื่นในหน้าตาเว็บไซต์ก่อน",
    "issues_title": "กรุณาตรวจ:",
    "ref_issue": {
      "not_found": "ไม่พบ “{{target}}” แล้ว",
      "unpublished": "“{{target}}” ยังไม่แสดงบนเว็บ — รายการนี้จะถูกซ่อน",
      "deleted": "“{{target}}” ถูกลบแล้ว",
      "handle_changed": "“{{target}}” เปลี่ยนที่อยู่เว็บแล้ว"
    },
    "warning": {
      "other": "มีรายการที่ลิงก์ไปยังสิ่งที่อาจใช้ไม่ได้"
    },
    "preview": "เว็บพร้อมเมนูนี้",
    "preview_hint": "แสดงเมนูที่บันทึกแล้ว กดบันทึกเพื่อดูที่แก้ตรงนี้",
    "preview_frame": "ตัวอย่างเว็บพร้อมเมนู"
  },
  "link": {
    "kind": "ชนิดลิงก์",
    "target_collection": "หมวดสินค้า",
    "target_filtered": "หมวดสินค้า + ตัวกรอง (เช่น เฉพาะ Rank A)",
    "target_product": "สินค้า",
    "target_page": "หน้าข้อมูล",
    "target_policy": "หน้านโยบายร้าน",
    "target_search": "การค้นหา",
    "target_url": "ที่อยู่อื่น",
    "target_none": "ไม่มีลิงก์ (เป็นหัวข้อ)",
    "pick_collection": "เลือกหมวดสินค้า",
    "pick_product": "เลือกสินค้า",
    "pick_page": "เลือกหน้า",
    "pick_policy": "เลือกหน้านโยบายร้าน",
    "filter_rank": "สภาพการ์ด (Rank)",
    "rank": "Rank {{rank}}",
    "filter_type": "ชนิดสินค้า",
    "type_any": "ทุกชนิด",
    "type_raw_single": "การ์ดใบเดี่ยว (ไม่เกรด)",
    "type_graded_single": "การ์ดเกรด",
    "type_sealed_product": "สินค้าซีล",
    "search_words": "คำค้นหา",
    "search_placeholder": "เช่น pikachu",
    "address": "ที่อยู่",
    "goes_to": "ลิงก์ไปที่: {{path}}",
    "problem_missing_target": "เลือกว่าลิงก์ไปที่ไหน",
    "problem_url_invalid": "ใช้ที่อยู่ที่ขึ้นต้นด้วย https:// หรือ / (หน้าของร้าน)"
  },
  "redirects": {
    "title": "ลิงก์เปลี่ยนเส้นทาง",
    "intro": "เมื่อที่อยู่เว็บเปลี่ยน คนที่เปิดที่อยู่เดิมจะถูกพาไปที่อยู่ใหม่",
    "tab_redirects": "ลิงก์เปลี่ยนเส้นทาง",
    "tab_not_found": "ลิงก์ที่ไม่พบ (404)",
    "search": "ค้นหา",
    "source": "ที่มา",
    "source_all": "ทั้งหมด",
    "source_manual": "เพิ่มเอง",
    "source_auto": "อัตโนมัติ",
    "source_import": "นำเข้าจากไฟล์",
    "add": "เพิ่มลิงก์เปลี่ยนเส้นทาง",
    "add_title": "ลิงก์เปลี่ยนเส้นทางใหม่",
    "edit_title": "แก้ลิงก์เปลี่ยนเส้นทาง",
    "import": "นำเข้าจากไฟล์",
    "export": "ดาวน์โหลดเป็นไฟล์",
    "from": "ที่อยู่เดิม",
    "to": "ที่อยู่ใหม่",
    "from_hint": "ไม่ต้องใส่ภาษา เช่น /products/old-card",
    "to_hint": "หน้าของร้าน (/collections/pokemon) หรือ https://…",
    "kind": "ชนิด",
    "kind_301": "ย้ายถาวร (แนะนำ)",
    "kind_302": "ชั่วคราว",
    "hits": "ถูกใช้",
    "actions": "การทำงาน",
    "pick": "เลือก",
    "pick_row": "เลือก {{from}}",
    "off": "ปิดอยู่",
    "switch_off": "ปิด",
    "switch_on": "เปิด",
    "created": "เพิ่มลิงก์เปลี่ยนเส้นทางแล้ว",
    "updated": "แก้ลิงก์เปลี่ยนเส้นทางแล้ว",
    "count_other": "{{count}} รายการ",
    "empty": "ยังไม่มีลิงก์เปลี่ยนเส้นทาง",
    "delete_picked": "ลบ {{count}} รายการที่เลือก",
    "delete_title_other": "ลบ {{count}} รายการ?",
    "delete_body": "คนที่เปิดที่อยู่เดิมจะเห็น “ไม่พบหน้านี้”",
    "deleted_other": "ลบแล้ว {{count}} รายการ",
    "import_title": "นำเข้าลิงก์เปลี่ยนเส้นทางจากไฟล์",
    "import_intro": "ไฟล์ CSV ที่มีคอลัมน์ from,to (และ status) ระบบจะตรวจไฟล์ก่อน — ยังไม่บันทึกจนกว่าจะกดยืนยัน",
    "import_file": "เลือกไฟล์",
    "import_paste": "…หรือวางเนื้อหา",
    "import_check": "ตรวจไฟล์",
    "checking": "กำลังตรวจ…",
    "import_back": "เลือกไฟล์อื่น",
    "import_confirm_other": "นำเข้า {{count}} แถว",
    "import_summary": "{{total}} แถว: นำเข้าได้ {{valid}} แถว, มีปัญหา {{errors}} แถว (จะข้าม)",
    "import_running": "กำลังนำเข้า… {{done}} จาก {{total}}",
    "import_errors_other": "แถวที่มีปัญหา {{count}} แถว",
    "import_failed": "การนำเข้าหยุดกลางทาง ไม่มีอะไรเปลี่ยน ลองใหม่อีกครั้ง",
    "imported": "นำเข้าแล้ว: ใหม่ {{created}}, แก้ {{updated}}, ข้าม {{skipped}}",
    "row": "แถว",
    "problem": "ปัญหา",
    "code": {
      "from_invalid": "ที่อยู่เดิมไม่ถูกต้อง — ต้องขึ้นต้นด้วย /",
      "locale_prefix": "ไม่ต้องใส่ภาษาข้างหน้า (/ja/…)",
      "system_route": "ที่อยู่นี้เป็นของระบบร้าน เปลี่ยนเส้นทางไม่ได้",
      "to_invalid": "ที่อยู่ใหม่ไม่ถูกต้อง",
      "status_invalid": "ชนิดต้องเป็น 301 หรือ 302",
      "duplicate_in_file": "ที่อยู่เดิมนี้ซ้ำในไฟล์",
      "redirect_loop": "จะทำให้ลูกค้าวนกลับมาที่เดิม",
      "redirect_chain_too_long": "ส่งต่อกันหลายทอดเกินไป",
      "self_redirect": "ที่อยู่เดิมกับที่อยู่ใหม่เหมือนกัน",
      "other": "แถวนี้นำเข้าไม่ได้"
    },
    "not_found_intro": "ที่อยู่ที่ลูกค้าเปิดแล้วไม่พบ ส่งพวกเขาไปหน้าที่มีประโยชน์",
    "not_found_empty": "ไม่มีลิงก์ที่ไม่พบ — ดีมาก",
    "not_found_count_other": "ถูกเปิด {{count}} ครั้ง · ล่าสุด {{time}}",
    "create_for": "สร้างลิงก์เปลี่ยนเส้นทาง",
    "dismiss": "ซ่อน"
  },
  "announcements": {
    "title": "ประกาศ",
    "intro": "ข้อความสั้นในแถบด้านบนของเว็บ",
    "add": "เพิ่มประกาศ",
    "add_title": "ประกาศใหม่",
    "edit_title": "แก้ประกาศ",
    "empty": "ยังไม่มีประกาศ",
    "created": "เพิ่มประกาศแล้ว",
    "saved": "บันทึกประกาศแล้ว",
    "conflict": "มีคนอื่นแก้ประกาศนี้ ปิดแล้วเปิดใหม่อีกครั้ง",
    "text": "ข้อความ",
    "text_hint": "ไม่เกิน 200 ตัวอักษร",
    "text_required": "ใส่ข้อความประกาศ",
    "link": "เมื่อคลิกจะไปที่",
    "starts": "เริ่ม",
    "starts_hint": "เวลาญี่ปุ่น เว้นว่าง = ตอนนี้",
    "ends": "สิ้นสุด",
    "ends_hint": "เวลาญี่ปุ่น เว้นว่าง = จนกว่าจะปิดเอง",
    "ends_before_starts": "เวลาสิ้นสุดต้องหลังเวลาเริ่ม",
    "languages": "แสดงในภาษา",
    "all_languages": "ทุกภาษา",
    "only_languages": "เฉพาะ {{languages}}",
    "markets": "แสดงกับลูกค้าใน",
    "all_markets": "ทุกประเทศ",
    "only_markets": "เฉพาะ {{markets}}",
    "market_JP": "ญี่ปุ่น",
    "market_US": "สหรัฐฯ",
    "market_EU": "ยุโรป",
    "market_UK": "สหราชอาณาจักร",
    "market_TW": "ไต้หวัน",
    "market_HK": "ฮ่องกง",
    "market_SG": "สิงคโปร์",
    "market_TH": "ไทย",
    "market_ROW": "ประเทศอื่น",
    "colors": "สี",
    "colors_default": "สีมาตรฐานของแถบ",
    "scheme": "ชุดสี {{n}}",
    "active": "เปิดใช้",
    "on": "เปิด",
    "off": "ปิด",
    "switch": "แสดง “{{text}}”",
    "state_live": "กำลังแสดง",
    "state_live_until": "กำลังแสดง · ถึง {{time}}",
    "state_scheduled": "ตั้งเวลาไว้",
    "state_scheduled_at": "จะแสดง {{time}}",
    "state_ended": "จบแล้ว",
    "state_inactive": "ปิดอยู่",
    "sample": "ตัวอย่างแถบประกาศ",
    "sample_language": "ภาษาของตัวอย่าง",
    "sample_empty": "ข้อความของคุณจะแสดงตรงนี้",
    "preview_site": "ดูบนเว็บ (ประกาศที่บันทึกแล้ว)",
    "preview_frame": "ตัวอย่างเว็บพร้อมแถบประกาศ",
    "delete_title": "ลบประกาศนี้?",
    "delete_body": "ประกาศจะหายจากเว็บ"
  },
  "translations": {
    "title": "คำแปล",
    "intro": "ทุกข้อความของเว็บในทุกภาษา กรองที่ยังไม่แปลแล้วเติมให้ครบ",
    "progress": "ความคืบหน้าการแปลแต่ละภาษา",
    "progress_of": "แปลเป็น{{language}}แล้ว",
    "progress_text": "{{translated}} จาก {{total}} · ยังขาด {{missing}}",
    "language": "ภาษา",
    "kind": "ประเภท",
    "kind_all": "ทั้งหมด",
    "kind_page": "หน้าเว็บ",
    "kind_policy": "นโยบายร้าน",
    "kind_menu": "เมนู",
    "kind_announcement": "ประกาศ",
    "kind_theme": "ข้อความในหน้าตาเว็บไซต์",
    "kind_ui_strings": "ข้อความบนเว็บ (ปุ่ม ป้าย)",
    "kind_media": "คำอธิบายรูป",
    "search": "ค้นหา",
    "missing_only": "เฉพาะที่ยังไม่แปล",
    "copied_only": "เฉพาะที่คัดลอกมา / ต้องตรวจ",
    "save_other": "บันทึก {{count}} รายการ",
    "suggest_other": "แปลอัตโนมัติ {{count}} รายการที่เลือก",
    "suggested": "เติมคำแปลที่แนะนำ {{count}} รายการแล้ว — ตรวจก่อนบันทึก",
    "mt_off": "ยังไม่ได้เปิดใช้การแปลอัตโนมัติ กรุณาแปลเอง",
    "export_csv": "ดาวน์โหลด CSV",
    "export_json": "ดาวน์โหลด JSON",
    "import": "อัปโหลด CSV",
    "import_ready": "ไฟล์พร้อมแล้ว",
    "import_check": "ตรวจไฟล์",
    "import_summary": "{{total}} แถว: จะเปลี่ยน {{changed}}, เหมือนเดิม {{unchanged}}, มีปัญหา {{skipped}}",
    "import_row": "แถว {{row}}: ",
    "import_confirm_other": "บันทึก {{count}} รายการ",
    "imported": "นำเข้าแล้ว: เปลี่ยน {{changed}}, ข้าม {{skipped}}",
    "saved_other": "บันทึกคำแปลแล้ว {{count}} รายการ",
    "saved_publish_other": "บันทึกคำแปลแล้ว {{count}} รายการ ต้องเผยแพร่หน้านโยบายร้าน {{policies}} หน้าจึงจะแสดง",
    "count_other": "แสดง {{count}} รายการ · ยังไม่แปลเป็น{{language}} {{missing}} รายการ",
    "all_done": "แปลครบแล้ว",
    "empty": "ไม่พบข้อความ",
    "table_label": "ข้อความภาษา{{language}}",
    "col_what": "อยู่ที่",
    "col_english": "อังกฤษ",
    "pick_row": "เลือก {{what}}",
    "edit_label": "{{what}} เป็น{{language}}",
    "status_missing": "ยังไม่แปล",
    "status_draft": "ต้องตรวจ",
    "status_reviewed": "แปลแล้ว",
    "copy_en": "คัดลอกอังกฤษ",
    "rich_has": "ข้อความจัดรูปแบบ — แปลแล้ว",
    "rich_missing": "ข้อความจัดรูปแบบ — ยังไม่แปล",
    "rich_edit": "แก้ที่หน้าจอของมัน",
    "website_texts_link": "ข้อความบนเว็บ (ปุ่ม ป้าย) →",
    "resource": {
      "page": "หน้าเว็บ",
      "policy": "นโยบายร้าน",
      "menu": "เมนู",
      "announcement": "ประกาศ",
      "template": "หน้าตาเว็บไซต์",
      "section_group": "หน้าตาเว็บไซต์",
      "ui_strings": "ข้อความบนเว็บ",
      "media": "รูป"
    },
    "import_error": {}
  },
  "ui_strings": {
    "title": "ข้อความบนเว็บ",
    "intro": "ปุ่ม ป้าย และข้อความต่าง ๆ บนเว็บ คำใน { } ระบบเติมให้ — ให้คงไว้เหมือนภาษาอังกฤษ",
    "groups": "กลุ่มข้อความ",
    "search": "ค้นหาด้วยรหัสหรือข้อความ",
    "count_other": "{{count}} ข้อความ",
    "empty": "ไม่พบข้อความ",
    "table_label": "ข้อความบนเว็บภาษา{{language}}",
    "edit_label": "{{key}} เป็น{{language}}",
    "core": "ข้อความหลัก",
    "saved_other": "บันทึกแล้ว {{count}} ข้อความ",
    "fix_first_other": "แก้ {{count}} ข้อความที่เป็นสีแดงก่อนบันทึก",
    "unknown_placeholder": "{{names}} ไม่มีในข้อความภาษาอังกฤษ — เว็บจะแสดงออกมาตรง ๆ",
    "missing_placeholder": "ข้อความนี้ไม่มี {{names}} ที่อยู่ในภาษาอังกฤษ",
    "icu": {
      "unclosed": "มี { ที่ยังไม่ปิดด้วย }",
      "unopened": "มี } ที่ไม่มี { — ถ้าจะแสดง } ให้ใส่ในเครื่องหมาย '",
      "double_braces": "ใส่ { } คู่เดียวรอบชื่อ ไม่ใช่สองคู่",
      "name_expected": "ต้องมีชื่อหลัง {",
      "format_expected": "ต้องมีรูปแบบ (number, date, plural …) หลังเครื่องหมายจุลภาค",
      "unknown_format": "“{{detail}}” ไม่ใช่รูปแบบที่รู้จัก",
      "choice_unsupported": "ไม่รองรับ “choice” — ใช้ plural หรือ select",
      "plural_choice": "“{{detail}}” ไม่ใช่ตัวเลือกของ plural (zero, one, two, few, many, other หรือ =N)",
      "choice_expected": "ต้องมีตัวเลือก ({…})",
      "choice_twice": "ตัวเลือก “{{detail}}” ซ้ำ",
      "other_required": "ต้องมีตัวเลือก “other”",
      "too_deep": "ข้อความซ้อนกันลึกเกินไป",
      "unexpected": "ไม่ควรมี “{{detail}}” ตรงนี้",
      "brace_in_style": "ห้ามมี { ในรูปแบบ"
    },
    "problem": {
      "placeholder_mismatch": "คำใน { } ไม่ตรงกับภาษาอังกฤษ",
      "placeholder_missing": "ขาดคำใน { } ของภาษาอังกฤษ",
      "icu_syntax_invalid": "ข้อความมีปัญหาเรื่อง { หรือ }",
      "translations_outdated": "ข้อความภาษาอังกฤษเปลี่ยน — ตรวจคำแปลอีกครั้ง"
    },
    "ns": {
      "common": "ทั่วไป",
      "header": "ส่วนบนของเว็บ",
      "footer": "ส่วนท้ายของเว็บ",
      "home": "หน้าแรก",
      "product": "หน้าสินค้า",
      "rank": "Rank การ์ด A–D",
      "collection": "หน้าหมวดสินค้า",
      "filters": "ตัวกรอง",
      "search": "ค้นหา",
      "cart": "ตะกร้า",
      "checkout": "ชำระเงิน",
      "payment": "การจ่ายเงิน",
      "tracking": "ติดตามคำสั่งซื้อ",
      "account": "บัญชีลูกค้า",
      "policies": "นโยบายร้าน",
      "errors": "ข้อความแจ้งปัญหา",
      "a11y": "สำหรับโปรแกรมอ่านหน้าจอ",
      "seo": "การค้นหาบน Google"
    }
  },
  "languages": {
    "title": "ภาษา",
    "intro": "เว็บแสดงภาษาอะไรบ้าง และลูกค้าจะได้ภาษาของตัวเองอย่างไร",
    "list": "ภาษาของเว็บ",
    "needs_manager": "เจ้าของร้านหรือผู้จัดการเท่านั้นที่เปลี่ยนภาษาได้ — เว็บเปลี่ยนทันที",
    "default": "ภาษาหลัก",
    "on": "เปิด",
    "off": "ปิด",
    "shown": "แสดงบนเว็บ",
    "hidden": "ไม่แสดง",
    "switch": "แสดง{{language}}บนเว็บ",
    "default_locked": "เปิดเสมอ — เป็นภาษาหลัก",
    "translated": "แปลแล้ว {{percent}}%",
    "go_translate": "ไปแปลส่วนที่ขาด",
    "turned_on": "เว็บแสดง{{language}}แล้ว",
    "turned_off": "เว็บไม่แสดง{{language}}แล้ว",
    "off_title": "หยุดแสดง{{language}}?",
    "off_body": "ลูกค้าจะไม่ถูกพาไปหน้า{{language}}อีก และ Google จะไม่แสดงหน้าภาษานี้ ข้อความยังเก็บไว้ เปิดใหม่ได้ภายหลัง",
    "off_confirm": "หยุดแสดง",
    "default_title": "ภาษาหลัก",
    "default_value": "{{language}} (ล็อก)",
    "default_reason": "ภาษาหลักเป็นภาษาอังกฤษเสมอ เพราะที่อยู่เว็บที่ไม่มีภาษาและผลค้นหาของ Google ใช้ภาษานี้ ภาษาอื่นที่ยังไม่แปลจะแสดงภาษาอังกฤษแทน",
    "detection_title": "เมื่อลูกค้าเข้าเว็บครั้งแรก",
    "detection_intro": "เลือกว่าจะทำอย่างไรเมื่อมีคนเปิดเว็บครั้งแรก:",
    "mode_auto_redirect": "พาไปภาษาของลูกค้าอัตโนมัติ",
    "mode_auto_redirect_effect": "ลูกค้าญี่ปุ่นจะถูกพาไปหน้าภาษาญี่ปุ่นอัตโนมัติครั้งแรก และระบบจำตัวเลือกไว้",
    "mode_banner": "แนะนำภาษาของลูกค้า",
    "mode_banner_effect": "หน้ายังเป็นภาษาอังกฤษ พร้อมแถบเล็ก ๆ “ดูหน้านี้เป็นภาษาญี่ปุ่น?”",
    "mode_off": "ไม่ทำอะไร",
    "mode_off_effect": "ทุกคนเห็นตามที่อยู่ที่เปิด และเปลี่ยนภาษาเองได้",
    "mode_saved": "บันทึกแล้ว เว็บจะใช้กับลูกค้าใหม่",
    "conflict": "มีคนอื่นเปลี่ยนการตั้งค่าภาษาพร้อมกัน หน้าจอแสดงค่าล่าสุดแล้ว — ลองใหม่อีกครั้ง"
  },
  "media": {
    "title": "รูปและไฟล์",
    "intro": "รูปทั้งหมดของเว็บอยู่ที่นี่ อัปโหลดจากคอมหรือมือถือ ใส่คำอธิบายสั้น ๆ และดูว่าแต่ละรูปใช้อยู่ที่ไหน",
    "focal_label": "ส่วนของรูปที่ต้องการให้เห็นเสมอ",
    "focal_value": "{{x}} จากซ้าย, {{y}} จากบน",
    "focal_set": "เวลารูปถูกตัดให้พอดีกรอบ จุดนี้จะยังเห็นอยู่",
    "focal_hint": "แตะส่วนที่สำคัญที่สุดของรูป (เช่น ตัวการ์ด) เพื่อให้ยังเห็นเมื่อรูปถูกตัดให้พอดีกรอบ",
    "focal_clear": "กลับไปใช้ตรงกลาง",
    "folder": "โฟลเดอร์",
    "folders": "โฟลเดอร์",
    "all_files": "รูปและไฟล์ทั้งหมด",
    "folder_name_needed": "พิมพ์ชื่อโฟลเดอร์",
    "folder_name_taken": "มีโฟลเดอร์ชื่อนี้อยู่แล้ว",
    "folder_failed": "เปลี่ยนโฟลเดอร์ไม่สำเร็จ ลองอีกครั้ง",
    "folder_too_deep": "โฟลเดอร์ซ้อนกันได้ไม่เกิน 5 ชั้น",
    "folder_new": "โฟลเดอร์ใหม่",
    "folder_rename": "เปลี่ยนชื่อ",
    "folder_delete": "ลบโฟลเดอร์",
    "folder_new_inside": "ชื่อโฟลเดอร์ใหม่ใน \"{{name}}\"",
    "folder_new_top": "ชื่อโฟลเดอร์ใหม่",
    "folder_rename_label": "ชื่อใหม่ของโฟลเดอร์",
    "folder_top": "(ไม่อยู่ในโฟลเดอร์)",
    "folder_deleted_other": "ลบโฟลเดอร์แล้ว ย้ายรูป {{count}} รูปขึ้นไปหนึ่งชั้น",
    "folder_has_folders": "ลบโฟลเดอร์ที่อยู่ข้างในก่อน",
    "folder_delete_title": "ลบโฟลเดอร์นี้ไหม?",
    "folder_delete_body": "รูปข้างในไม่ถูกลบ แต่จะย้ายขึ้นไปหนึ่งชั้น",
    "detail_failed": "โหลดรายละเอียดของรูปนี้ไม่ได้",
    "saved": "บันทึกแล้ว",
    "save_media_down": "ระบบเก็บรูปไม่ตอบ จึงยังไม่ได้บันทึก รอสักครู่แล้วลองอีกครั้ง",
    "save_forbidden": "คุณไม่มีสิทธิ์แก้รูป ขอให้ผู้จัดการช่วย",
    "save_failed": "บันทึกไม่สำเร็จ ลองอีกครั้ง",
    "remove_failed": "ลบรูปไม่สำเร็จ ลองอีกครั้ง",
    "untitled": "รูปไม่มีชื่อ",
    "detail_close": "ปิดรายละเอียด",
    "open_file": "เปิดไฟล์",
    "alt_title": "คำอธิบายรูป",
    "alt_hint": "บอกสั้น ๆ ว่าในรูปมีอะไร เครื่องมือค้นหาและคนที่มองไม่เห็นรูปจะอ่านข้อความนี้",
    "alt_missing_en": "รูปนี้ยังไม่มีคำอธิบายภาษาอังกฤษ — ต้องใส่ก่อนใช้บนเว็บ",
    "alt_missing": "ยังว่าง: {{languages}}",
    "alt_needed": "ต้องมี",
    "alt_placeholder": "เช่น การ์ด Umbreon VMAX ด้านหน้า",
    "tags": "แท็ก",
    "tag_remove": "เอาแท็ก {{tag}} ออก",
    "tags_placeholder": "พิมพ์แท็กแล้วกด Enter",
    "save": "บันทึกการแก้ไข",
    "discard": "ยกเลิกที่แก้",
    "used_where": "ใช้อยู่ที่",
    "used_nowhere": "ยังไม่ได้ใช้ที่ไหน",
    "in_use_title": "รูปนี้ยังอยู่บนเว็บ",
    "in_use_body": "เปลี่ยนที่เหล่านี้เป็นรูปอื่นก่อน แล้วค่อยลบ:",
    "remove": "ลบรูป",
    "remove_title": "ลบรูปนี้ออกจากรายการไหม?",
    "remove_body": "รูปจะถูกซ่อนจากรายการ รูปที่ยังใช้บนเว็บลบไม่ได้",
    "use_template": "ดีไซน์เว็บ — หน้า \"{{page}}\"",
    "use_group": "ดีไซน์เว็บ — {{area}}",
    "use_settings": "ดีไซน์เว็บ — โลโก้ / ไอคอน",
    "use_page": "หน้า \"{{name}}\"",
    "use_policy": "นโยบายร้าน — {{name}}",
    "use_menu": "เมนู \"{{name}}\"",
    "use_live": "อยู่บนเว็บ",
    "use_draft": "อยู่ในร่างเท่านั้น",
    "search": "ค้นหารูป",
    "search_placeholder": "ชื่อ คำอธิบาย หรือแท็ก",
    "tag": "แท็ก",
    "tag_any": "ทุกแท็ก",
    "kind": "ประเภท",
    "kind_any": "ทั้งหมด",
    "kind_image": "รูป",
    "kind_video": "วิดีโอ",
    "kind_file": "ไฟล์ (PDF)",
    "upload": "อัปโหลดรูป",
    "upload_files": "อัปโหลดไฟล์",
    "camera": "ถ่ายรูป",
    "upload_rules": "JPEG, PNG, WebP, GIF หรือ HEIC (iPhone) รูปละไม่เกิน 25 MB ลากรูปมาวางตรงนี้ก็ได้",
    "upload_rules_file": "รูปไม่เกิน 25 MB หรือ PDF ไม่เกิน 20 MB ลากไฟล์มาวางตรงนี้ก็ได้",
    "video_links": "วิดีโอใส่เป็นลิงก์ YouTube หรือ Vimeo ในส่วนนั้นของหน้า",
    "list_failed": "โหลดรูปไม่ได้",
    "retry": "ลองอีกครั้ง",
    "none_found": "ไม่พบ \"{{q}}\"",
    "empty": "ยังไม่มีรูปตรงนี้ อัปโหลดรูปแรกได้เลย",
    "count_other": "{{count}} รูป",
    "results": "รูป",
    "detail": "รายละเอียดรูป",
    "no_alt_badge": "ไม่มีคำอธิบาย",
    "picked": "เลือกแล้ว",
    "uploads": "การอัปโหลด",
    "uploads_busy_other": "กำลังอัปโหลด {{count}} ไฟล์…",
    "uploads_done_other": "อัปโหลดแล้ว {{count}} ไฟล์",
    "uploads_clear": "ล้างรายการ",
    "problem": {
      "type": "ไฟล์ชนิดนี้ใช้ไม่ได้ ใช้ JPEG, PNG, WebP, GIF หรือ HEIC",
      "too_large": "ไฟล์ใหญ่เกินไป (รูปไม่เกิน 25 MB)",
      "empty": "ไฟล์ว่างเปล่า",
      "network_error": "การเชื่อมต่อหลุด ตรวจอินเทอร์เน็ตแล้วลองอีกครั้ง",
      "processing_timeout": "รูปใช้เวลาเตรียมนาน เดี๋ยวจะขึ้นมาเอง หรือกดลองอีกครั้ง",
      "mime_mismatch": "ไฟล์ข้างในไม่ใช่ชนิดตามชื่อไฟล์",
      "unsupported_media_type": "ไฟล์ชนิดนี้ใช้ไม่ได้",
      "size_mismatch": "ไฟล์มาไม่ครบ ลองอีกครั้ง",
      "corrupt_file": "ไฟล์เสีย เปิดไม่ได้",
      "processing_failed": "เตรียมรูปไม่สำเร็จ อัปโหลดใหม่อีกครั้ง",
      "pdf_invalid": "เปิด PDF ไม่ได้",
      "file_too_large": "ไฟล์ใหญ่เกินไป",
      "upload_quota_exceeded": "อัปโหลดพร้อมกันมากเกินไป รอสักครู่แล้วลองอีกครั้ง",
      "upload_not_received": "ไฟล์ส่งไม่ถึง ลองอีกครั้ง",
      "purpose_not_allowed": "อัปโหลดไฟล์ชนิดนี้ตรงนี้ไม่ได้",
      "forbidden": "คุณไม่มีสิทธิ์อัปโหลด ขอให้ผู้จัดการช่วย",
      "other": "อัปโหลดไฟล์ไม่สำเร็จ"
    },
    "upload_status": {
      "waiting": "รอคิว",
      "uploading": "กำลังส่ง",
      "processing": "กำลังเตรียมรูป",
      "ready": "เสร็จแล้ว",
      "failed": "ส่งไม่สำเร็จ",
      "rejected": "ไม่รับไฟล์นี้",
      "cancelled": "หยุดแล้ว"
    },
    "upload_cancel": "หยุดอัปโหลด {{name}}",
    "upload_progress": "การอัปโหลด {{name}}",
    "picker_hint": "เลือกรูป หรืออัปโหลดรูปใหม่ แตะรูปแล้วกด \"ใช้รูปนี้\"",
    "picker_hint_many": "เลือกรูปหนึ่งรูปขึ้นไป หรืออัปโหลดรูปใหม่",
    "picked_count_other": "เลือกแล้ว {{count}}",
    "use_many_other": "ใช้ {{count}} รูป",
    "use_picture": "ใช้รูปนี้",
    "use_file": "ใช้ไฟล์นี้",
    "alt_off": "ภาษานี้ยังไม่เปิดบนเว็บ"
  }
}
